import { create } from 'zustand';

import type { InspectTarget } from '../wire';

export interface MenuItem {
  kind: 'inspect' | 'walk' | 'fish';
  label: string;
  entityType: 'avatar' | 'prop' | 'building' | 'terrain';
  target: InspectTarget;
}

export interface ContextMenuState {
  open: boolean;
  screenX: number;
  screenY: number;
  tileQ: number;
  tileR: number;
  items: MenuItem[];

  show: (x: number, y: number, q: number, r: number, items: MenuItem[]) => void;
  close: () => void;
}

export const useContextMenu = create<ContextMenuState>((set) => ({
  open: false,
  screenX: 0,
  screenY: 0,
  tileQ: 0,
  tileR: 0,
  items: [],

  show: (screenX, screenY, tileQ, tileR, items) =>
    set({ open: true, screenX, screenY, tileQ, tileR, items }),

  close: () =>
    set({ open: false, screenX: 0, screenY: 0, tileQ: 0, tileR: 0, items: [] }),
}));
